import {Component, OnInit} from '@angular/core';
import {PlaylistService} from '../service/playlist.service';
import {MessageService} from '../service/message.service';
import {PlaylistInfo} from '../model/playlist-info';

@Component({
  selector: 'app-playlists',
  templateUrl: './playlists.component.html',
  styleUrls: ['./playlists.component.css']
})
export class PlaylistsComponent implements OnInit {
  playlists: PlaylistInfo[];

  constructor(private messageService: MessageService,
              private playlistService : PlaylistService) { }

  ngOnInit() {
    this.playlistService.list().subscribe(
      v =>  this.playlists = v,
      err => this.messageService.addDefaultError(err)
    );
  }

  onDeletePlaylist(playlist: PlaylistInfo) {
    if (confirm("Are you sure that you want to delete this playlist?")) {
      this.playlistService.delete(playlist.id)
        .subscribe(v => {
          let idx: number = this.playlists.indexOf(playlist);
          this.playlists.splice(idx, 1);
        }, err => this.messageService.addDefaultError(err));
    }
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/playlists/playlists.component.ts